<template>
  <a-card>
    <div class="descrition-instructions">
      <div>温馨提示：</div>
      <div>出库代表您退出{{sys_title}}专家库，您将不再被抽取参与采购活动，也无法再登录本专家管理系统。</div>
      <div>出库申请由{{sys_title}}审核通过后即刻生效，您将收到短信提醒。</div>
      <div>出库后如需重新入库，您可以拨打咨询电话或重新填报资料申请入库。</div>
    </div>
    <div v-if="hasOutApplyFor">
      <div class="text-center">
        <p class="font-size-big color-red">您于{{outApplyForData.applyForDate | dateChineseFormat}}提交了出库申请，目前在等待{{ sys_title }}审核。</p>
        <p class="font-size-big">感谢您一直以来的陪伴和付出，期待下一次的合作！</p>
      </div>
      <div class="flex-center">
        <a-button class="mt-5"
                  type="danger"
                  @click="onWithdraw()">撤回申请</a-button>
      </div>
    </div>
    <div v-else>
      <a-form-model :model="expertOutForm"
                    ref="expertOutForm"
                    :rules="rules">
        <a-row type="flex"
               justify="center">
          <a-col :span="24">
            <a-form-model-item label="出库原因"
                               prop="outReason">
              <a-textarea v-model="expertOutForm.outReason"
                          :auto-size="{ minRows: 4 }" />
            </a-form-model-item>
          </a-col>
        </a-row>

      </a-form-model>
      <div class="flex-center mt-4">
        <a-button type="primary"
                  :loading="saveLoading"
                  @click="onSubmit">提交出库申请</a-button>
      </div>
    </div>
  </a-card>
</template>
<script>
import { GetExpertByUserId, SaveOutApplyFor, GetOutApplyForByExpertId, WithdrawOutApplyFor } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import expertAuditResultEnum from '@/utils/expertAuditResultEnum'
import { SYS_TITLE } from '@/store/mutation-types'

export default {
  name: 'ExpertStockOutAdd',
  data () {
    return {
      sys_title: this.$ls.get(SYS_TITLE),
      saveLoading: false,
      expertInfo: {},
      expertOutForm: {},
      rules: {
        expertName: [{ required: true, message: '专家名称', trigger: 'change' }],
        outReason: [{ required: true, message: '请输入出库原因', trigger: 'blur' }, { max: 500, message: '最多500个字', trigger: 'change' }]
      },
      outApplyForData: {},
      hasOutApplyFor: false
    }
  },
  created () {
    this.getExpert()
  },
  methods: {
    async getExpert () {
      try {
        let res = await GetExpertByUserId()
        const result = res.result
        this.expertInfo = result
        this.expertOutForm = {
          expertName: result.expertName,
          expertId: result.id,
          outReason: ''
        }
        this.getOutApplyFor(result.id)
      } catch (e) {
      } finally {
      }
    },
    async getOutApplyFor (expertId) {
      let res = await GetOutApplyForByExpertId(expertId)
      if (res.code == 200 && res.result.length > 0) {
        const result = res.result.find(item => item.auditStatus === expertAuditResultEnum.AUDIT_ING)
        if (result) {
          this.outApplyForData = result
          this.hasOutApplyFor = true
          this.expertOutForm.outReason = result.outReason
        }
      }
    },
    onSubmit () {
      const that = this
      this.$refs.expertOutForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        this.$confirm({
          title: '确定提交出库申请吗?',
          onOk () {
            that.handleSubmit()
          },
        })
      })
    },
    async handleSubmit () {
      this.saveLoading = true
      const res = await SaveOutApplyFor(this.expertOutForm)
      if (res.code == 200) {
        this.$message.success('提交成功')
      } else {
        this.$message.error(res.msg)
      }
      this.getOutApplyFor(this.expertInfo.id)
      this.saveLoading = false
    },
    // 撤回申请
    async onWithdraw () {
      const that = this
      this.$confirm({
        title: '确定撤销出库申请吗?',
        onOk () {
          that.onHandleWithdraw()
        },
      })
    },
    async onHandleWithdraw () {
      const res = await WithdrawOutApplyFor(this.expertInfo.id)
      if (res.code == 200) {
        this.$message.success('撤销成功')
        this.hasOutApplyFor = false
      }
    },
  }
}
</script>

<style lang="less" scoped>
.flex-center {
  display: flex;
  justify-content: center;
}
.font-size-big {
  font-size: 24px;
}
.text-center {
  text-align: center;
}
.color-red {
  color: red;
  font-weight: bold;
}
.descrition-instructions {
  padding: 10px;
  background-color: #fff3e9;
  margin-bottom: 15px;
  font-size: 16px;
}
</style>
